// Keep this JS entrypoint as a compatibility bridge.
// The real implementation is in useDashboard.ts.
import { useDashboard as useDashboardTs } from './useDashboard.ts';

export const useDashboard = options => useDashboardTs(options);

export default useDashboard;
